import { Dialog, DialogContent, IconButton, InputAdornment, makeStyles } from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { formatDate } from 'app/utils/mask';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import AdornmentTextInput from './AdornmentTextInput';
import TextLabel from './TextLabel';

const editLabel = (label) => {
  return !!label ? `${label}` : '';
};

const dateInputStyles = makeStyles({
  dialogContent: {
    '&.MuiDialogContent-root': {
      padding: 0,
    },
  },
  input: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'pink !important',
      },
    },
  },
});

const DateInput = (props) => {
  const {
    id,
    name,

    required,
    readOnly,

    label,
    format = 'DD/MM/YYYY',
    fullWidth,
    disableFuture,

    value,

    onChange,
    onBlur,

    touched,
    error,
    helperText = 'Campo é obrigatório',
    autoFocus,
    minDate,
    disabled,
    views,
    openTo,
    labelWidth,
  } = props;

  const formatDateString = (_value) => {
    let _dateString = _value;

    if (value?.format) {
      _dateString = _value.format(format);
    } else if (typeof value === 'string') {
      _dateString = moment(_value).format(format);
    }

    return _dateString;
  };

  const [dateString, setDateString] = useState(formatDateString(value));
  const [open, setOpen] = useState(false);
  const styles = dateInputStyles();

  useEffect(() => {
    setDateString(formatDateString(value));
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (readOnly) {
    return <TextLabel disabled id={id} label={label} value={value ? moment(value).format(format) : ''} />;
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (_, date) => {
    if (date) {
      setDateString(date);
      setOpen(false);
      onChange({ target: { id, value: moment(date, format) } });
    }
  };

  const handleChangeString = ({ target: { value: _dateValue } }) => {
    const dateValue = _dateValue.replace('/', '').replace('/', '');
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(dateValue) || dateValue.length > 8 || (format === 'MM/YYYY' && dateValue.length > 6)) {
      return;
    }

    if (!dateValue.length) {
      onChange({ target: { id, value: null } });
    }

    const date = moment(dateValue, format);

    setDateString(dateValue);
    if (date.isValid()) {
      if (
        (format === 'DD/MM/YYYY' && dateValue.length === 8) ||
        (format === 'MM/YYYY' && dateValue.length === 6) ||
        (format === 'YYYY' && dateValue.length === 4)
      ) {
        onChange({ target: { id, value: date } });
      }
    }
  };

  return (
    <>
      <AdornmentTextInput
        id={id}
        name={name}
        onChange={handleChangeString}
        value={dateString ? formatDate(dateString || '') : ''}
        touched={touched}
        onBlur={onBlur}
        label={label}
        labelWidth={labelWidth}
        className={styles.input}
        error={error}
        helperText={helperText}
        autoFocus={autoFocus}
        required={required}
        fullWidth
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="calendar" edge="end" onClick={handleOpen} disabled={disabled}>
              <DateRangeIcon />
            </IconButton>
          </InputAdornment>
        }
        disabled={disabled}
      />
      <Dialog aria-labelledby="dateRangePicker-dialog-title" open={open} onClose={handleClose}>
        <DialogContent className={styles.dialogContent}>
          <KeyboardDatePicker
            autoOk
            id={id}
            name={id}
            label={editLabel}
            format={format}
            fullWidth={fullWidth}
            disableFuture={disableFuture}
            inputVariant="outlined"
            variant="static"
            value={value}
            error={error}
            // se for null, dispara erro
            minDate={minDate || undefined}
            InputLabelProps={{ shrink: true }}
            helperText={error && helperText}
            onChange={handleChange}
            onBlur={onBlur}
            invalidDateMessage="Data inválida"
            views={views}
            openTo={openTo}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DateInput;
